import React from 'react';
import { useNavigate } from 'react-router-dom';  // ページ遷移用のフック
// グローバル CSS のクラス名を使用

/**
 * Props:
 * - ellipseInfo: object (全楕円情報)
 * - checkedEllipse: array (選択中の楕円リスト)
 * - imageUrl: string (解析対象の画像URL)
 * - buttonText: string (ボタン表示テキスト)
 */
function ToBottomDetection({ ellipseInfo, imageUrl, buttonText = "Bottom Detection画面へ遷移" ,userId = null  }) {
    const navigate = useNavigate();

    const handleClick = async () => {
      // ellipseInfo の isChecked を参照して選択があるか確認
      const selectedEntries = Object.entries(ellipseInfo || {}).filter(([, v]) => Number(v.isChecked || 0) === 1);

      if (!selectedEntries || selectedEntries.length === 0) {
        alert('少なくとも1つの楕円を選択してください。');
        return;
      }

      // 選択された楕円情報を配列に変換
      const selectedInfos = selectedEntries.map(([key, value]) => value);

      try {
        // バックエンドにチェックした楕円情報を送信
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
        const response = await fetch(`${apiUrl}/checkedEllipse`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ellipses: selectedInfos }),
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        console.log('サーバーからの応答:', data);

        // 更新された画像と楕円情報を取得
        const updatedImageUrl = data.image ? `data:image/png;base64,${data.image}` : imageUrl;
        const updatedEllipseInfo = data.ellipses || ellipseInfo;

        // 状態を sessionStorage に保存
        try {
          sessionStorage.setItem('ellipseInfo', JSON.stringify(updatedEllipseInfo));
          if (updatedImageUrl) sessionStorage.setItem('ellipseImageUrl', updatedImageUrl);
        } catch (e) {
          console.warn('sessionStorage not available:', e);
        }

        // 更新された情報を使って画面遷移
        navigate('/bottomDetection', {
          state: {
            ellipses: updatedEllipseInfo,
            imageUrl: updatedImageUrl,
            userId: userId,
          }
        });
      } catch (error) {
        console.error('Error:', error);
        alert('楕円情報の取得中にエラーが発生しました');
      }
    };

  // 決定: ellipseInfo の isChecked===1 を持つ要素があるかどうかでボタンの有効/無効を決める
  const hasSelection = Object.entries(ellipseInfo || {}).some(([, v]) => Number(v.isChecked || 0) === 1);

  return (
    <button
      onClick={handleClick}
      className={hasSelection ? 'btn btn--danger' : 'btn btn--danger opacity-50 cursor-not-allowed'}
      disabled={!hasSelection}
      aria-disabled={!hasSelection}
      title={!hasSelection ? '少なくとも1つの楕円を選択してください' : buttonText}
    >
        {buttonText}
    </button>
  );
}

export default ToBottomDetection;